import { Component, Input, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { placeholder } from 'src/app/models/placeholder';
import { SmartDatePipe } from 'src/app/pipes/smart-date.pipe';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { HelperService } from 'src/app/services/helper/helper.service';

interface ActivityCarousel {
  orderId: string;
  logo: string;
  displayName: string;
  bookingDateTime: string;
  image: string;
  airportName: string;
  flightNo: string;
  location: string;
  adult: string;
  children: string;
  infant: string;
  src: string;
  originAirport: any;
  status: string;
  duration: string;
  destinationAirport: any;
  dest: string;
  pickupDateTime: string;
  airlineName: string;
  noOfPax: string;
  legId: string;
}
@Component({
  selector: 'activity-carousel',
  templateUrl: './activity-carousel.component.html',
  styleUrls: ['./activity-carousel.component.scss'],
})
export class ActivityCarouselComponent implements OnInit {
  @Input() activities: any;
  @Input() baseUrl: string;
  carouselList: ActivityCarousel[];
  public imagePlaceholder = placeholder;

  constructor(
    private navController: NavController,
    private analyticsService: AnalyticsService,
    public helperService: HelperService,
    private smartDatePipe: SmartDatePipe
  ) {}

  ngOnInit() {
    const list = [];
    this.activities?.map((items) => {
      if (items?.type === 'order') {
        list?.push({
          id: items?.order?.orderId,
          orderId: items?.order?.orderId,
          logo: items?.order?.logo,
          displayName: items?.order?.displayName,
          bookingDateTime: items?.order?.bookingDateTime,
          image: items?.order?.image,
          airportName: items?.order?.airportName,
          flightNo: items?.order?.flightNo,
          location: items?.order?.location,
          adult: items?.order?.adult,
          children: items?.order?.children,
          infant: items?.order?.infant,
          type: items?.type,
          src: items?.src,
          originAirport: items?.originAirport,
          status: items?.status,
          duration: items?.duration,
          destinationAirport: items?.destinationAirport,
          dest: items?.dest,
          pickupDateTime: items?.order?.pickupDateTime,
          airlineName: items?.order?.airlineName,
          noOfPax: items?.order?.numOfPax,
          legId: items?.order?.legid,
        });
      } else if (items?.type === 'baggageInsurance') {
        list?.push({
          orderId: items?.baggageInsurance?.orderId,
          logo: items?.baggageInsurance?.logo,
          displayName: items?.baggageInsurance?.displayName,
          bookingDateTime: items?.baggageInsurance?.bookingDateTime,
          image: items?.baggageInsurance?.image,
          airportName: items?.baggageInsurance?.airportName,
          flightNo: items?.baggageInsurance?.flightNo,
          location: items?.baggageInsurance?.location,
          adult: items?.baggageInsurance?.adult,
          children: items?.baggageInsurance?.children,
          infant: items?.baggageInsurance?.infant,
          type: items?.type,
          src: items?.src,
          originAirport: items?.originAirport,
          status: items?.status,
          duration: items?.duration,
          destinationAirport: items?.destinationAirport,
          dest: items?.dest,
          pickupDateTime: items?.baggageInsurance?.pickupDateTime,
          airlineName: items?.baggageInsurance?.airlineName,
          noOfPax: items?.baggageInsurance?.numOfPax,
          legId: items?.baggageInsurance?.legid,
        });
      } else if (items?.type === 'serviceBooking') {
        list?.push({
          orderId: items?.serviceBooking?.orderId,
          logo: items?.serviceBooking?.logo,
          displayName: items?.serviceBooking?.displayName,
          bookingDateTime: items?.serviceBooking?.bookingDateTime,
          image: items?.serviceBooking?.image,
          airportName: items?.serviceBooking?.airportName,
          flightNo: items?.serviceBooking?.flightNo,
          location: items?.serviceBooking?.location,
          bags: items?.serviceBooking?.bags,
          adult: items?.serviceBooking?.adult,
          children: items?.serviceBooking?.children,
          infant: items?.serviceBooking?.infant,
          type: items?.type,
          src: items?.src,
          originAirport: items?.originAirport,
          status: items?.status,
          duration: items?.duration,
          destinationAirport: items?.destinationAirport,
          dest: items?.dest,
          pickupDateTime: items?.serviceBooking?.pickupDateTime,
          airlineName: items?.serviceBooking?.airlineName,
          noOfPax: items?.serviceBooking?.numOfPax,
          legId: items?.serviceBooking?.legid,
          serviceName: items?.serviceBooking?.serviceName,
          experienceTime: items?.serviceBooking?.experienceTime,
        });
      } else if (items?.type === 'upcomingFlight') {
        list?.push({
          orderId: items?.upcomingFlight?.orderId,
          logo: items?.upcomingFlight?.logo,
          displayName: items?.upcomingFlight?.displayName,
          bookingDateTime: items?.upcomingFlight?.bookingDateTime,
          image: items?.upcomingFlight?.image,
          airportName: items?.upcomingFlight?.airportName,
          flightNo: items?.upcomingFlight?.flight_no,
          location: items?.upcomingFlight?.location,
          adult: items?.upcomingFlight?.adult,
          children: items?.upcomingFlight?.children,
          infant: items?.upcomingFlight?.infant,
          type: items?.type,
          src: items?.upcomingFlight?.src,
          originAirport: items?.upcomingFlight?.originAirport,
          status: items?.upcomingFlight?.status,
          duration: items?.upcomingFlight?.duration,
          destinationAirport: items?.upcomingFlight?.destinationAirport,
          dest: items?.upcomingFlight?.dest,
          pickupDateTime: items?.upcomingFlight?.pickupDateTime,
          airlineName: items?.upcomingFlight?.airline_name,
          noOfPax: items?.upcomingFlight?.numOfPax,
          legId: items?.upcomingFlight?.legid,
        });
      }
    });
    this.carouselList = [...list];
  }

  navigate(item) {
    const url =
      item?.type === 'order'
        ? '/dutyfreeV2/order/' + item?.id
        : item?.type === 'upcomingFlight'
        ? '/flight/' + item?.legId
        : '/service/booking-details/' + item?.orderId;
    this.navController.navigateForward(url);
    this.analyticsService.trackUnified('activity_carousel_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'activity_carousel_clicked',
      component: 'activity-carousel-component',
      button: 'card',
    });
  }

  calculateTotalTime(departureTime: any, arrivalTime: any) {
    const [h, m] = this.helperService.calculateTravelDuration(
      departureTime,
      arrivalTime
    );
    if (!isNaN(h) && !isNaN(m)) {
      return `${h}h ${m}m`;
    }
    return '';
  }

  getTime(date: any) {
    if (date) {
      return this.smartDatePipe.transform(date, 'HH:mm');
    }
    return '';
  }

  datesDiffer(date1, date2) {
    if (!date1 || !date2) {
      return false;
    }
    return date1.getTime() !== date2.getTime();
  }

  isExpectedActualDep(airportDetails) {
    if (!airportDetails?.actual_dep && !airportDetails?.expected_dep) {
      return false;
    }
    const scheduled = new Date(airportDetails?.scheduled_dep);

    if (airportDetails?.actual_dep) {
      const actual = new Date(airportDetails?.actual_dep);
      if (actual && this.datesDiffer(actual, scheduled)) {
        return airportDetails?.actual_dep;
      }
    }

    if (airportDetails?.expected_dep) {
      const expected = new Date(airportDetails?.expected_dep);
      if (expected && this.datesDiffer(expected, scheduled)) {
        return airportDetails?.expected_dep;
      }
    }
    return false;
  }

  isExpectedActualArr(airportDetails) {
    if (!airportDetails?.actual_arr && !airportDetails?.expected_arr) {
      return false;
    }
    const scheduled = new Date(airportDetails?.scheduled_arr);

    if (airportDetails?.actual_arr) {
      const actual = new Date(airportDetails?.actual_arr);
      if (actual && this.datesDiffer(actual, scheduled)) {
        return airportDetails?.actual_arr;
      }
    }

    if (airportDetails?.expected_arr) {
      const expected = new Date(airportDetails?.expected_arr);
      if (expected && this.datesDiffer(expected, scheduled)) {
        return airportDetails?.expected_arr;
      }
    }
    return false;
  }

  formatDate(dateString: string): string {
    let date = new Date(dateString);
    if (date.toString() === 'Invalid Date') {
      date = new Date(this.smartDatePipe.normalizeFormat(dateString));
    }
    return this.smartDatePipe.transform(date, 'dd MMM yyyy') || '';
  }
}
